export default __webpack_public_path__ + "static/media/actividad-46.2696d4ec.mp3";